import InfoRow from "./InfoRow"
import ErrorView from "../ErrorView"

export default function ErrorRow(props) {
    const { type, colSpan } = props
    return <InfoRow colSpan={colSpan}  >
        <ErrorView type={type} />
    </InfoRow>
}